import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { balloonsCardMotion } from './motion';
import { balloonsChromeTone } from './palette';

export const balloonsTheme: FlowThemeDefinition = {
  id: 'balloons',
  label: 'Balloons',
  description: 'A hot-air balloon festival on a bright morning: every answer launches a balloon, and you rise above the clouds.',
  category: 'daylight',
  chromeTone: balloonsChromeTone,
  swatch: 'linear-gradient(180deg, #4F86CB 0%, #9CC3EA 46%, #FFE2BE 60%, #9DD06B 61%, #E8C97F 82%, #A897D8 100%)',
  cardGlass: 'default',
  cardMotion: balloonsCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createBalloonsScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
